import { render, staticRenderFns } from "./PscDeficiencySummary.vue?vue&type=template&id=1ac11971&scoped=true&"
import script from "./PscDeficiencySummary.vue?vue&type=script&lang=js&"
export * from "./PscDeficiencySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac11971",
  null
  
)

export default component.exports